// Angular imports
import { Injectable } from '@angular/core';

// Rxjs imports
import { Observable, Subject } from 'rxjs';

// Interface imports
import { ILocalContextFactory } from '../../dashboard-module/_interfaces/local-context-factory';

// Service imports
import { ContextManagerService } from './context-manager.service';

// Constant imports
import { DataRefreshKeyConstants } from '../../_constants/data-refresh-key-constants';

@Injectable()
export class WidgetContextFactoryService implements ILocalContextFactory {
    subjectDataRefresh = new Subject<DataRefreshKeyConstants>();

    private readonly _subjectWidgetContext = new Subject<any>();
    private _widgetContext: any;

    constructor(private readonly contextManagerService: ContextManagerService) {
        this._widgetContext = this.contextManagerService.getSelectedContext();
    }

    getContext(): Observable<any> {
        return this._subjectWidgetContext;
    }

    getLocalContext() {
        return this._widgetContext;
    }

    updateContext(context: any): void {
        this._widgetContext = context;
        this._subjectWidgetContext.next(context);
    }
}
